"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const SearchContentButton_1 = require("./SearchContentButton");
const RefreshButton_1 = require("./RefreshButton");
const ClosePanelButton_1 = require("./ClosePanelButton");
exports.ContentImportPanelToolbarControls = () => {
    return (react_2.default.createElement(react_1.OsmosysDiv, { osysName: "ContentImportPanel.toolbar.right", flexRow: true, marginLeft: "sm", padding: "sm" },
        react_2.default.createElement(RefreshButton_1.ContentImportPanelRefreshButton, null),
        react_2.default.createElement(SearchContentButton_1.ContentImportPanelSearchContentButton, null),
        react_2.default.createElement(ClosePanelButton_1.ContentImportPanelClosePanelButton, null)));
};
//# sourceMappingURL=Controls.js.map